import { Modal, ModalContent, ModalOverlay } from "@chakra-ui/react"
import { ReactElement } from "react"
import { useNavigate } from "react-router-dom"

export const ModalPainel = ({ children }: { children: ReactElement | ReactElement[] }) => {

    const navigate = useNavigate();

    return (

        <Modal isOpen={true} onClose={() => navigate('..')}>
            <ModalOverlay />
            <ModalContent bg={'transparent'} shadow='none'>
                <>{children}</>
            </ModalContent>
        </Modal>
    )
}